const BRAND_NAME = window.globalConfig?.INSTALLATION_NAME || 'Impact Omnibot';

// Keep upstream URLs, SDK identifiers and API headers intact in translated copy.
const BRAND_TOKEN = /chatwoot[a-z]*/gi;

const brandText = text =>
  text
    .replaceAll('app.chatwoot.com/hc/', 'impact-omnibot.impactfirst.co/hc/')
    .replace(BRAND_TOKEN, (token, index, source) => {
      const before = source.slice(0, index);
      const after = source.slice(index + token.length);
      const suffix = token.slice('chatwoot'.length);

      if (suffix && /^[A-Z]/.test(suffix)) return token;
      if (/[A-Za-z0-9_@./:]$/.test(before) || /X-$/i.test(before)) {
        return token;
      }
      if (/^\.[A-Za-z0-9_]/.test(after) || /^[/_]|^:[A-Za-z0-9_]/.test(after)) {
        return token;
      }
      return BRAND_NAME;
    });

export const brandTranslations = translations => {
  if (typeof translations === 'string') return brandText(translations);
  if (Array.isArray(translations)) return translations.map(brandTranslations);
  if (translations && typeof translations === 'object') {
    return Object.fromEntries(
      Object.entries(translations).map(([key, value]) => [
        key,
        brandTranslations(value),
      ])
    );
  }
  return translations;
};
